import localStyles from "../components/Bonus3Section/styles.module.scss";
import {ProductType} from "../context/Contexts";

declare global {
    interface Window {
        scs_custom_rear_seats?: boolean;
    }
}

//window.scs_biz2 ? "http://localhost:8000" :
export const getApiBase = () => "https://scsbiz3.wearevisum.com";

export const slugify = function (str: string) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = ucFirst(str); // convert string to lowercase
    str = str.replace(/[^a-zA-Z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, ''); // remove consecutive hyphens
    return str;
}

export const slugifyWithDash = function (str: string) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = ucFirst(str); // convert string to lowercase
    str = str.replace(/&/g, 'and');
    str = str.replace(/[^a-zA-Z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
}

export const ucFirst = function (word: string) {
    return word.charAt(0).toUpperCase()
        + word.slice(1);
}

export const getCurrency = function (currencyCode: string) {
    return currencyCode === 'USD' ? '$' : currencyCode;
}

export const getFormattedSeatValue = function (label, price, comparePrice, customCompatibility) {
    let subtitle = '';
    let value = label;
    let diff: string = '';
    let diffPercentage: string = '';
    let comparePrice1 = comparePrice;
    if (comparePrice) {
        const comparePriceNum = parseFloat(comparePrice.replace(/[^0-9.]/g, ''));
        const priceNum = parseFloat(price.replace(/[^0-9.]/g, ''));
        diff = '' + formatShopifyMoney(formatMoney(comparePriceNum - priceNum));
        diffPercentage = '' + ((comparePriceNum - priceNum) / comparePriceNum * 100).toFixed(0);
    }
    switch (label) {
        case 'Claim This Deal':
            subtitle = 'The Ultimate Upgrade For Your Seat Covers';
            comparePrice1 = '';
            diff = '$299+ (Value)';
            break;
        case 'First Row':
            value = 'First Row';
            subtitle = '2 Front Seats';
            if (customCompatibility === 'Y' || customCompatibility === 'F' || customCompatibility === 'YF') {
                value = 'Front Seats';
            }
            break;
        case 'Back Row':
            value = 'Back Row';
            subtitle = '1 Back Bench';
            if (customCompatibility === 'Y' || customCompatibility === 'YF') {
                value = 'Rear Seats Only';
            }
            break;
        case 'Middle Row':
            value = 'Middle Row';
            subtitle = '2 Seats';
            break;
        case 'Front Seats':
            value = 'Front Seats';
            subtitle = '2 Front Seats';
            if (window.scs_black_friday_2025) {
                value = 'Front Seats Only';
            }
            break;
        case 'Universal Back Bench':
            value = 'Rear Seats Only';
            subtitle = '1 Universal Rear';
            break;
        case 'First Row & Back Row':
            value = 'Bundle';
            subtitle = '2 Fronts & 1 Back';
            break;
        case 'Second or Third Row':
            if (customCompatibility === 'Y' || customCompatibility === 'YJ') {
                value = 'Second Row';
                subtitle = 'Rear Seats';
            }
            break;
        case '2 Row Bundle':
            if (customCompatibility === 'Y' || customCompatibility === 'YJ') {
                value = 'Bundle';
                subtitle = '';
            }
            break;
        case 'Bundle':
            value = `Front & Rear Seats`;
            if (customCompatibility === 'N') {
                subtitle = '2 Fronts & 1 Back';
            }
            if (customCompatibility === 'Y' || customCompatibility === 'F'
                || customCompatibility === 'YF' || customCompatibility === 'YJ'
                || customCompatibility === 'FJ' || customCompatibility === 'TJ') {
                subtitle = '2 Fronts & 1 Back';
            }
            if (customCompatibility === 'T') {
                subtitle = 'All Rows';
            }
            if (window.scs_ultimate_upgrade) {
                value = 'Front & Back Seats';
                subtitle = 'Front & Rear Seats (2 fronts & 1 back bench)';
            }
            if (window.scs_black_friday_2025) {
                value = 'Front & Rear Seats';
            }
            break;
    }

    return {value, subtitle, diff, diffPercentage, comparePrice: comparePrice1};
}

export const formatSelectedSeat = function (selectedSeat: string | undefined, product: any, compatibility_custom: string) {
    let price = '';
    let comparePrice = '';
    const parsed_seat = parseSeatValue(selectedSeat, compatibility_custom);
    // No priced product to look up (e.g. the video-only flow has no Shopify
    // product association) — fall back to the plain seat name so the summary
    // still shows what was selected, just without a price.
    if (!product || !product.variants || !product.variants.edges) {
        return parsed_seat;
    }
    const priceEl = product.variants.edges.filter(v => v.node.selectedOptions
        .filter(er => er.name === 'Seats' && er.value === parsed_seat).length > 0);
    // console.log('priceEl:', priceEl);
    if (priceEl.length > 0) {
        const currency = getCurrency(priceEl[0].node.priceV2.currencyCode);
        price = currency + formatMoney(getOfferPrice(parseFloat(priceEl[0].node.priceV2.amount)));

        if (priceEl[0].node.compareAtPrice) {
            comparePrice = currency + formatMoney(parseFloat(priceEl[0].node.compareAtPrice.amount));
        }

        const {value, subtitle, diff} = getFormattedSeatValue(parsed_seat, price, comparePrice, compatibility_custom);
        return `${parsed_seat} (${subtitle} - ${price})`;
    }

    // No priced variant matched this seat — still show the seat name itself.
    return parsed_seat;
}

export const getImageUrl = function (src, maxWidth, maxHeight) {

    let size = maxWidth + 'x';
    if (maxHeight) {
        size += maxHeight;
    }
    let newSrc = src.replace('.jpg', '_' + size + '.jpg');
    newSrc = newSrc.replace('.png', '_' + size + '.png');
    newSrc = newSrc.replace('.webp', '_' + size + '.webp');
    if (newSrc.indexOf('?') > -1) {
        newSrc = newSrc.replace('?', '?crop=center&format=pjpg&');
    } else {
        newSrc = newSrc + '?crop=center&format=pjpg&';
    }

    return newSrc;
}

export const parseSeatValue = function (seatValue, compatibility_custom) {
    // console.log('compatibility_custom', compatibility_custom);
    let seat = seatValue || '';
    switch (seat) {
        case 'First Row,Back Row':
            seat = 'First Row & Back Row';
            break;
        case 'Back Row,First Row':
            seat = 'First Row & Back Row';
            break;
        case 'Middle Row,Back Row':
            seat = 'Middle Row & Back Row';
            break;
        case 'Back Row,Middle Row':
            seat = 'Middle Row & Back Row';
            break;
        case 'First Row,Middle Row':
            seat = 'First Row & Middle Row';
            break;
        case 'Middle Row,First Row':
            seat = 'First Row & Middle Row';
            break;

        default:
            break;
    }
    return seat;
}

export const parsedSeatUserFriendly = function (seatValue, compatibility_custom) {
    let seat = seatValue || '';
    // console.log('parsedSeatUserFriendly', seatValue, compatibility_custom);
    if (compatibility_custom === 'YF' || compatibility_custom === 'Y') {
        seat = seat.replace('First Row & Back Row', 'Bundle');
    }
    if (compatibility_custom === 'F' || compatibility_custom === 'Y' || compatibility_custom === 'YF') {
        seat = seat.replace('First Row', 'Front Seats');
    }
    if (compatibility_custom === 'Y' || compatibility_custom === 'YF') {
        seat = seat.replace('Back Row', 'Back Bench');
    }
    //console.log('parsedSeatUserFriendly result', seat);
    return seat;
}

export const isCustom = function (currentAppData) {
    return currentAppData.check && (currentAppData.check.compatibility === 'N'
        && currentAppData.check.compatibility_custom !== 'N');
}

export const isCustomThreeRows = function (currentAppData) {
    return false;
    // return currentAppData.check && (currentAppData.check.compatibility === 'N'
    //     && currentAppData.check.compatibility_custom === 'T');
}

export const isCustomFront = function (currentAppData) {
    return currentAppData.check && (
        (currentAppData.check.compatibility_custom === 'F'
            || currentAppData.check.compatibility_custom === 'FJ'));
}

export const isCustomFrontJump = function (currentAppData) {
    return currentAppData.check && (
        window.scs_force_normal !== true &&
        (currentAppData.check.compatibility_custom === 'YF'
            || currentAppData.check.compatibility_custom === 'FJ')
    );
}

export const isCustomJump = function (currentAppData) {
    return currentAppData.check && (currentAppData.check.compatibility === 'N'
        &&
        (currentAppData.check.compatibility_custom === 'YJ'
            || currentAppData.check.compatibility_custom === 'FJ'
            || currentAppData.check.compatibility_custom === 'TJ'
            || currentAppData.check.compatibility_custom === 'YF'
        )
    );
}

export const formatMoney = function (money) {
    return window.scs_force_custom ? money.toFixed(2) : money.toFixed(0);
}

/**
 * Format a price amount using Shopify's active currency rate and money format.
 * Falls back gracefully when Shopify globals are not present.
 *
 * @param amount - The raw price amount in the shop's base currency (e.g. 149.99)
 * @returns Formatted price string with currency symbol (e.g. "$150" or "CA$210.00")
 */
export const formatShopifyMoney = function (amount: number): string {
    const rate: number = (window as any).Shopify?.currency?.rate
        ? parseFloat((window as any).Shopify.currency.rate)
        : 1;

    const converted = amount * rate;

    // Shopify money_format strings use placeholders like {{amount}}, {{amount_no_decimals}}, etc.
    const moneyFormat: string =
        (window as any).Shopify?.money_format ?? '${{amount}}';

    // Determine the placeholder being used and format accordingly
    if (moneyFormat.includes('{{amount_no_decimals_with_comma_separator}}')) {
        const formatted = Math.round(converted)
            .toFixed(0)
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            .replace(/\.(\d{2})$/, ',$1');
        return moneyFormat.replace('{{amount_no_decimals_with_comma_separator}}', formatted);
    }
    if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
        const formatted = converted
            .toFixed(2)
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return moneyFormat.replace('{{amount_with_comma_separator}}', formatted);
    }
    if (moneyFormat.includes('{{amount_no_decimals}}')) {
        return moneyFormat.replace('{{amount_no_decimals}}', Math.round(converted).toFixed(0));
    }
    // Default: {{amount}} – 2 decimal places, but drop trailing .00 for cleaner display
    const formatted = window.scs_force_custom
        ? converted.toFixed(2)
        : Math.round(converted).toFixed(0);
    return moneyFormat.replace('{{amount}}', formatted);
};

export const isRear = function (currentAppData) {
    return window.scs_show_bonus_section && currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 || currentAppData?.seat?.indexOf('Back') !== -1 || currentAppData?.seat?.indexOf('Front') !== -1);
}

export const isFront = function (currentAppData) {
    return window.scs_show_bonus_section && currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 || currentAppData?.seat?.indexOf('Front') !== -1);
}

export const isBundle = function (currentAppData) {
    return window.scs_show_bonus_section && currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1);
}

export const getOfferPrice = function (price: number) {
    if (window.scs_show_earlybf_section || window.scs_father_day_2026) {
        return price - 20;
    }
    return price;
}

export const getCompareOfferPrice = function (price: number, compare_price: number) {
    if (window.scs_show_earlybf_section) {
        //console.debug('compare_price: ', compare_price, 'price: ', price);
        if (compare_price !== undefined) {
            return compare_price;
        }
        return price;
    }
    return compare_price;
}

export const getPriceElemById = function (variants, selectedId) {
    const filtered = variants && variants.edges.length > 0
                ? variants.edges.filter(
                    (el) =>
                        el.node.id.replace("gid://shopify/ProductVariant/", "") ===
                        "" + selectedId,
                )
                : [];
        //console.log("filtered", filtered);
    if (filtered.length == 0) {
        return [];
    }           

    if (window.scs_black_friday_2025) {
        if (!filtered[0].node.compareAtPrice) {
            filtered[0].node.compareAtPrice = {
                amount: 0,
                currency: 'USD',
            };
        }
        
        switch (filtered[0]?.node?.selectedOptions
            .filter(er => er.name === 'Seats')[0].value) {
            case 'Bundle':
                filtered[0].node.compareAtPrice.amount = cleanPrice(window.scs_promo_bonus_compare_price_1);//'783';//788.98
                filtered[0].node.priceV2.amount = cleanPrice(window.scs_promo_bonus_sale_price_1);//'369';
                break;
            case 'Universal Back Bench':
                filtered[0].node.compareAtPrice.amount = cleanPrice(window.scs_promo_bonus_compare_price_2);//'504';//509.98
                filtered[0].node.priceV2.amount = cleanPrice(window.scs_promo_bonus_sale_price_2);//'259';
                break;
            case 'Front Seats':
                filtered[0].node.compareAtPrice.amount = cleanPrice(window.scs_promo_bonus_compare_price_3);//'504';//509.98
                filtered[0].node.priceV2.amount = cleanPrice(window.scs_promo_bonus_sale_price_3);//'259';
                break;

        }
    }    
    return filtered;
}

export const getVariantMetafields = function (variants, selectedId) {
    const filtered = variants && variants.edges.length > 0
        ? variants.edges.filter(
            (el) =>
                el.node.id.replace("gid://shopify/ProductVariant/", "") ===
                "" + selectedId,
        )
        : [];
    if (filtered.length == 0) {
        return null;
    }

    let preorder_enabled = filtered[0].node.preorder_enabled?.value; 
    let preorder_ship_date = filtered[0].node.preorder_ship_date?.value;

    return {
        preorder_enabled: preorder_enabled,
        preorder_ship_date: preorder_ship_date
    };
}

export const getPriceElem = function (variants, name1) {
    const priceEl = variants.edges.filter(v => v.node.selectedOptions
        .filter(er => er.name === 'Seats' && er.value === name1).length > 0);
    if (priceEl.length == 0) {
        return [];
    }
    if (window.scs_black_friday_2025) {
        if (!priceEl[0].node.compareAtPrice) {
            priceEl[0].node.compareAtPrice = {
                amount: 0,
                currency: 'USD',
            };
        }
        switch (name1) {
            case 'Bundle':
                priceEl[0].node.compareAtPrice.amount = cleanPrice(window.scs_promo_bonus_compare_price_1);//788.99
                priceEl[0].node.priceV2.amount = cleanPrice(window.scs_promo_bonus_sale_price_1);
                break;
            case 'Universal Back Bench':
                priceEl[0].node.compareAtPrice.amount = cleanPrice(window.scs_promo_bonus_compare_price_2);//509.98
                priceEl[0].node.priceV2.amount = cleanPrice(window.scs_promo_bonus_sale_price_2);
                break;
            case 'Front Seats':
                priceEl[0].node.compareAtPrice.amount = cleanPrice(window.scs_promo_bonus_compare_price_3);//509.98
                priceEl[0].node.priceV2.amount = cleanPrice(window.scs_promo_bonus_sale_price_3);
                break;

        }
    }
    return priceEl;
}

const cleanPrice = (price) => {
    let price1 = (price || '').toString().replace(/[\$€#A-Za-z]/g, '').trim();
    //console.log('price1: ', price1);
    return price1;
}

export const getNewPartNumber = (currentAppData: {
    step?: number | undefined;
    seat?: string | undefined;
    color?: string | undefined;
    selectedId?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    check?: { compatibility: string; compatibility_custom: string; availability: object } | undefined;
    product?: ProductType | undefined;
    originalProduct?: ProductType | undefined;
    addons?: string | undefined;
    trim?: string | undefined;
    cab?: string | undefined;
    has_trims?: boolean | undefined;
    has_cabs?: boolean | undefined;
    with_bonus?: boolean | undefined;
    trims?: object | undefined | null;
    sku_mapping_availability?: Record<string, any> | null;
}) => {
    if (!currentAppData?.seat || !currentAppData?.color) {
        return null;
    }

    const seatKeyForSku = resolveAvailabilitySeatKey(currentAppData.seat, currentAppData.sku_mapping_availability ?? undefined);
    const skuMapNew = currentAppData.sku_mapping_availability?.[seatKeyForSku]?.['new_sku']?.[currentAppData.color];
    if (skuMapNew !== undefined && skuMapNew !== null) {
        return skuMapNew;
    }

    const frontSeatsNewSku = currentAppData.sku_mapping_availability?.["Front Seats"]?.["new_sku"];
    if (typeof frontSeatsNewSku === 'string' && frontSeatsNewSku) {
        return frontSeatsNewSku;
    }

    if (!currentAppData?.check) {
        return null;
    }
    const seatKeyForCheck = resolveAvailabilitySeatKey(currentAppData.seat, currentAppData?.check?.availability ?? undefined);
    if (!currentAppData?.check?.availability || !currentAppData?.check?.availability[seatKeyForCheck]) {
        console.log('NOT FOUND:', currentAppData.seat);
        return null;
    }
    if (!currentAppData?.check?.availability[seatKeyForCheck]['new_sku']) {
        console.log('NOT FOUND new_sku:', currentAppData.seat);
        return null;
    }
    if (typeof currentAppData?.check?.availability[seatKeyForCheck]['new_sku'][currentAppData.color] === 'undefined') {
        console.log('NOT FOUND color:', currentAppData.seat, currentAppData.color);
        return null;
    }
    return currentAppData?.check?.availability[seatKeyForCheck]['new_sku'][currentAppData.color];
}

export function resolveAvailabilitySeatKey(seat: string, availability: Record<string, any> | null | undefined): string {
    if (!seat) return seat;
    if (!availability) return seat;
    // Canonical aliases mapping: lookup synonyms for common seat keys
    const SEAT_KEY_ALIASES: Record<string, string[]> = {
        'Bundle': ['Set'],
        'Set': ['Bundle'],
        'Universal Back Bench': ['Rear Seats'],
        'Back Bench': ['Rear Seats'],
        'Rear Bench': ['Rear Seats'],
        'Rear Seat': ['Rear Seats'],
    };
    if (availability[seat] !== undefined) return seat;
    for (const alias of (SEAT_KEY_ALIASES[seat] ?? [])) {
        if (availability[alias] !== undefined) return alias;
    }
    // Also try reverse: if seat doesn't exist, check if any canonical maps to seat
    for (const [canonical, aliases] of Object.entries(SEAT_KEY_ALIASES)) {
        if (aliases.includes(seat) && availability[canonical] !== undefined) return canonical;
    }
    return seat;
}


export const MODEL_SORT_ORDER: Record<string, Record<string, number>> = {
    Ford: {
        'F-150': 9010,
        'F-250': 9009,
        'F-350': 9008,
        'Ranger': 9007,
    },
    Ram: {
        '1500': 8510,
        '2500': 8509,
        '3500': 8508,
    },
    Chevrolet: {
        'Silverado 1500': 8010,
        'Silverado 2500 HD': 8009,
        'Silverado 3500 HD': 8008,
        'Colorado': 8007,
    },
    GMC: {
        'Sierra 1500': 7510,
        'Sierra 2500 HD': 7509,
        'Sierra 3500 HD': 7508,
        'Canyon': 7507,
    },
    Dodge: {
        'Ram 1500': 7010,
        'Ram 2500': 7009,
        'Ram 3500': 7008,
    },
    Toyota: {
        'Tundra': 6510,
        'Tacoma': 6509,
        '4Runner': 6508,
    },
}

export const getTrims = (trims, model) => {
    if (trims == null || typeof trims === 'string') {
        return [];
    }
    if (typeof trims[model] === "undefined") {
        return [];
    }
    return [
        ...new Set(
            trims[model].map((item) => item.trim).filter((item) => item != ""),
        ),
    ].sort();
}

export const isCustomRearAvailable = function (currentAppData) {
    if (!window.scs_custom_rear_seats) return false;
    const compat = currentAppData?.check?.compatibility;
    const customCompat = currentAppData?.check?.compatibility_custom;
    const isFrontsOnly = compat === 'F' || compat === 'HF' || compat === 'AF' || compat === 'BF';
    return isFrontsOnly && customCompat && customCompat !== 'N';
}

export const getCustomRearOptions = function (customCompatibility) {
    if (customCompatibility === 'T' || customCompatibility === 'TJ') {
        return [
            { key: '2nd_row', label: 'Custom 2nd Row', price: 279, msrp: 458 },
            { key: '3rd_row', label: 'Custom 3rd Row', price: 279, msrp: 458 },
        ];
    }
    return [
        { key: 'rear_seat', label: 'Custom 2nd Row', price: 279, msrp: 458 },
    ];
}

export const handleColorChange = (currentAppData, newColor, id, setCurrentAppData) => {
        let id1 = id;
        const parsed_seat = parseSeatValue(currentAppData.seat, currentAppData?.check?.compatibility_custom);
        if (parsed_seat !== currentAppData.seat) {
            // find variant id for this specific parsed_seat
            // console.log('seat and color: ', parsed_seat, newColor);
            const seats_filtered = currentAppData.product.variants.edges.filter(v =>
                v.node.selectedOptions.filter(ep => ep.name === 'Seats' && ep.value === parsed_seat).length > 0);

            // console.log('seats_filtered: ', seats_filtered);
            const filtered_by_color = seats_filtered
                .filter(v => v.node.selectedOptions.filter(ep => ep.name === 'Color' && ep.value === newColor).length > 0);

            // console.log('filtered_by_color: ', filtered_by_color);
            if (filtered_by_color.length > 0)
                id1 = filtered_by_color[0].node?.id?.replace('gid://shopify/ProductVariant/', '');
            // console.log('selected id filtered: ' + id);
        }

        setCurrentAppData(prevState => {
            return { ...prevState, selectedId: id1 }
        })
        return id1;
    }